import * as React from "react";
import { cn } from "../../lib/utils";

export function Card({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "rounded-[2rem] border border-black/10 bg-white/85 p-6 shadow-[0_20px_60px_rgba(16,32,26,0.08)] backdrop-blur-xl transition hover:border-pink/40 hover:bg-white",
        className,
      )}
      {...props}
    />
  );
}

